import { ArrowRightOutlined } from '@ant-design/icons'
import { Horizontal } from '@gravitate-js/excalibrr'
import React from 'react'

export function OrderTerminals({ order, showShortName = true }) {
  if (!order.loads) return null

  return (
    <Horizontal style={{ flexWrap: 'wrap' }}>
      {order.loads.map((d, i) => {
        const locationName = (showShortName && d.location_short_name) || d.location_name || 'N/A'
        const showArrow = i !== order.loads.length - 1
        return (
          <div key={i}>
            {locationName}
            {showArrow && <ArrowRightOutlined style={{ color: 'var(--theme-color-2)' }} className='pl-1 pr-2' />}
          </div>
        )
      })}
    </Horizontal>
  )
}
